import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { SVButton } from './core';
import { MAX_TIME_INACTIVE, ONE_MINUTE } from '@/constants/common';
import { MESSAGES } from '@/constants/messages';
import showToast from '@/utils/toast';
import { logout } from '@/utils/api';

type IdleTimeoutModalProps = {
  isTest?: boolean;
};

export default function IdleTimeoutModal({
  isTest = false,
}: IdleTimeoutModalProps) {
  const [remaining, setRemaining] = useState<number>(MAX_TIME_INACTIVE);
  const [open, setOpen] = useState<boolean>(isTest);

  const onIdle = () => {
    showToast({ type: 'error', data: { content: MESSAGES.expiredSession } });
    logout();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: MAX_TIME_INACTIVE,
    promptBeforeIdle: ONE_MINUTE,
    throttle: 500,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const onStayLoggedIn = () => {
    activate();
  };

  return (
    <Dialog open={open}>
      <DialogTitle variant="h4">Session Timeout</DialogTitle>
      <DialogContent>
        <Typography>
          You will be logged out due to inactivty. Please choose to stay signed
          in or to log off. Otherwise, you will be logged off automatically.
        </Typography>
      </DialogContent>
      <DialogActions>
        <SVButton variant="outlined" onClick={logout}>
          Log Off
        </SVButton>
        <SVButton
          variant="primary"
          onClick={onStayLoggedIn}>{`Stay Logged In (${remaining})`}</SVButton>
      </DialogActions>
    </Dialog>
  );
}
